<mat-accordion>
    <mat-expansion-panel [expanded]="panelOpenState">
        <mat-expansion-panel-header class="v-bg-primary">
            <mat-panel-title>
                <span class="text-light fs-5 f-bold">New/Edit Roadbook</span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="neweventroadform">
            <div class="container pt-3">
                <div class="row">
                    <div class="col-sm">
                        <mat-form-field>
                            <input matInput formControlName="name" placeholder="Name">
                        </mat-form-field>
                        <mat-form-field *ngIf="(+neweventroadform.controls['roadbook_type'].value) !== 1 && (+neweventroadform.controls['roadbook_type'].value) !== 0">
                            <input matInput formControlName="code" placeholder="Code">
                        </mat-form-field>
                        <mat-form-field *ngIf="(+neweventroadform.controls['roadbook_type'].value) === 3">
                            <input matInput formControlName="activation_code" placeholder="Activation Code">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="interes" placeholder="Tourist interest">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput type="number" formControlName="distancia" placeholder="Distance (KM)">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput type="number" formControlName="duracio" placeholder="Duration (Hours)">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="estacionalitat" placeholder="Stationality">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput type="number" formControlName="pages" placeholder="Number of pages">
                        </mat-form-field>
                        <mat-checkbox formControlName="visible" [disabled]="(+neweventroadform.controls['destinated_users'].value) === 2">Visible</mat-checkbox>
                    </div>
                    <div class="col-sm">
                        <mat-form-field>
                            <mat-label>Roadbook Type</mat-label>
                            <mat-select formControlName="roadbook_type">
                                <mat-option [value]="1">Roadbook</mat-option>
                                <mat-option [value]="2">Roadbook Event</mat-option>
                                <mat-option [value]="-1">Roadbook Out of shop</mat-option>
                                <mat-option [value]="4">Roadbook Event On Demand</mat-option>
                                <mat-option [value]="5">Roadbook Event By QR</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field *ngIf="(+neweventroadform.controls['roadbook_type'].value) === 1">
                            <mat-label>Roadbook</mat-label>
                            <mat-select formControlName="roadbook" (valueChange)="selectedRoadbook($event)">
                                <!-- <mat-option>
                                    <ngx-mat-select-search></ngx-mat-select-search>
                                </mat-option> -->
                                <mat-option *ngFor="let rd of filteredRoadbooks | async" [value]="rd.id">
                                    {{rd.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="qr-link-field" *ngIf="(+neweventroadform.controls['roadbook_type'].value) === 5">
                            <mat-form-field class="mr-05">
                                <input matInput formControlName="qr_link" placeholder="QR Code">
                            </mat-form-field>
                            <button mat-button (click)="applyFirebaseUrl()" class="mt-1 min-w-123px btn btn-primary fs-14px" [disabled]="!existsRoadbookUrl()">Use Server Url</button>
                        </div>
                        <mat-form-field>
                            <input matInput formControlName="geolocalitzacio" placeholder="Geolocation (Latitude, Longitude)">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="geolocalitzacio2" placeholder="Geolocation 2">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="geolocalitzacio3" placeholder="Geolocation 3">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="geolocalitzacio4" placeholder="Geolocation 4">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="geolocalitzacio5" placeholder="Geolocation 5">
                        </mat-form-field>
                        <div class="w-100">
                            <input type="hidden" formControlName="path" placeholder="">
                            <button mat-button (click)="selectFolder()" class="mt-1"><mat-icon>folder</mat-icon> Select folder</button>
                            <span class="ml-2 w-100 text-right">{{ getSelectedFolder() }}</span>
                            <button mat-button *ngIf="neweventroadform.controls['path'].value" (click)="neweventroadform.controls['path'].setValue(null)" class="mt-1"><mat-icon>close</mat-icon></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container border-top mt-3 pt-3">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="input-full-width">
                            <h6>Roadbook</h6>
                            <app-upload [onlyOneFile]="true" [onlyPDF]="true" [files]="roadbookFile" title="File" subTitle="Drag files here" chooseText="or choose a file"></app-upload>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="input-full-width">
                            <h6>Guide</h6>
                            <app-upload [onlyOneFile]="true" [onlyPDF]="true" [files]="guideFile" title="File" subTitle="Drag files here" chooseText="or choose a file"></app-upload>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="input-full-width">
                            <h6>GPX</h6>
                            <app-upload [onlyOneFile]="true" [onlyGPX]="true" [files]="gpxFile" title="File" subTitle="Drag files here" chooseText="or choose a file"></app-upload>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-sm">
                        <mat-form-field class="input-full-width">
                            <mat-label>Administrator users</mat-label>
                            <input (keypress)="keyPressEmailAdministrator($event)" formControlName="emails_admin" type="text" matInput placeholder="Emails">
                        </mat-form-field>
                        <div>
                            <p style="background-color: #ebebeb; padding: 20px">Total emails: {{ emails_admin.length }}</p>
                            <ul *ngIf="emails_admin.length > 0" class="email-container" style="padding: 20px;list-style-type: none;">
                                <li style="margin-bottom: 20px;" *ngFor="let t of emails_admin">
                                    <span>{{ t }}</span>
                                    <button style="float:right;" mat-icon-button (click)="removeEmailAdmin(t)">
                                    <mat-icon>close</mat-icon>
                                </button>
                                    <hr>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm">
                        <ng-container *ngIf="(+neweventroadform.controls['roadbook_type'].value) === 5; else elseNoByQRTemplate">
                            <label for="file-upload" class="custom-file-upload btn btn-primary">
                                <i class="fa fa-cloud-upload"></i> Upload emails file
                            </label>
                            <input id="file-upload" type="file" (change)="onFileQRChange($event)" multiple="false" />
                            <mat-form-field class="input-full-width">
                                <input (keypress)="keyPressEmailQR($event)" formControlName="emailsqr" type="text" matInput placeholder="Emails">
                            </mat-form-field>
                            <div>
                                <p style="background-color: #ebebeb; padding: 20px">Total emails QR Scanned: {{ emails_qr.length }}</p>
                                <ul *ngIf="emails.length > 0" class="email-container" style="padding: 20px;list-style-type: none;">
                                    <li style="margin-bottom: 20px;" *ngFor="let t of emails_qr">
                                        <span>{{ t }}</span>
                                        <button style="float:right;" mat-icon-button (click)="removeEmailQR(t)">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                        <hr>
                                    </li>
                                </ul>
                            </div>
                        </ng-container>
                        <ng-template #elseNoByQRTemplate>
                            <mat-form-field>
                                <mat-label>Destinated user</mat-label>
                                <mat-select formControlName="destinated_users">
                                    <mat-option [value]="1">All</mat-option>
                                    <mat-option [value]="2">By Email</mat-option>
                                    <!-- <mat-option [value]="3">By QR</mat-option> -->
                                </mat-select>
                            </mat-form-field>
                            <ng-container *ngIf="(+neweventroadform.controls['destinated_users'].value) === 2">
                                <label for="file-upload" class="custom-file-upload btn btn-primary">
                                    <i class="fa fa-cloud-upload"></i> Upload emails file
                                </label>
                                <input id="file-upload" type="file" (change)="onFileChange($event)" multiple="false" />
                                <mat-form-field class="input-full-width">
                                    <input (keypress)="keyPressEmail($event)" formControlName="emails" type="text" matInput placeholder="Emails">
                                </mat-form-field>
                                <div>
                                    <p style="background-color: #ebebeb; padding: 20px">Total emails: {{ emails.length }}</p>
                                    <ul *ngIf="emails.length > 0" class="email-container" style="padding: 20px;list-style-type: none;">
                                        <li style="margin-bottom: 20px;" *ngFor="let t of emails">
                                            <span>{{ t }}</span>
                                            <button style="float:right;" mat-icon-button (click)="removeEmail(t)">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                            <hr>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </ng-template>
                    </div>
                </div>
            </div>

            <hr>
            <button (click)="saveEventRoad()" [disabled]="!neweventroadform.valid" class="btn btn-success">Save Roadbook</button>
            <button style="margin-left: 20px" (click)="reset()" class="btn btn-danger">Cancel</button>
        </form>
    </mat-expansion-panel>
</mat-accordion>
<h6 class="mt-3">Folders<button mat-button (click)="currentFolder = null; updateFolderTree()"><mat-icon>home</mat-icon></button>
    <ng-container *ngFor="let fi of pathFolders">/<button mat-button (click)="currentFolder = fi.i; updateFolderTree()">{{ fi.n }}</button></ng-container>
    <button mat-button *ngIf="currentFolder" class="px-0" style="min-width: 0;" (click)="editCurrentFolder()"><mat-icon>edit</mat-icon></button>
</h6>
<button mat-button (click)="addFolder()" class="mt-1"><mat-icon>create_new_folder</mat-icon> New folder</button>
<ng-container *ngFor="let fi of currentFolders">
    <button mat-button (click)="currentParentId = currentFolder; currentFolder = fi.i; updateFolderTree()"><mat-icon>folder</mat-icon> {{ fi.n }}
    <span *ngIf="getTotalRoadbooks(fi.i) > 0"> ({{getTotalRoadbooks(fi.i)}})</span>
</button>
    <button mat-button *ngIf="getTotalRoadbooks(fi.i) === 0" class="px-0" style="min-width: 0;" (click)="removeFolder(fi)"><mat-icon>delete</mat-icon></button>
</ng-container>
<h6 class="mt-3">Roadbooks</h6>
<mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtre">
</mat-form-field>

<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="star" stickyEnd>
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="editElemet(element)">
        <mat-icon>edit</mat-icon>
      </button>
                <button mat-icon-button (click)="removeElemet(element)">
        <mat-icon>delete</mat-icon>
      </button>
            </td>
        </ng-container>

        <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
            <td mat-cell *matCellDef="let row"> {{row.id}} </td>
        </ng-container> -->

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let row" (click)="expandedElement = expandedElement === row ? null : row"> {{row.name}} </td>
        </ng-container>

        <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
            <td mat-cell *matCellDef="let row" (click)="expandedElement = expandedElement === row ? null : row"> {{row.code}} </td>
        </ng-container>
        <ng-container matColumnDef="visible">
            <th mat-header-cell *matHeaderCellDef> Visible </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox style="margin-left: 20px!important;" [disabled]="row.destinated_users === 2" (change)="changeCheckBox(row, $event)" [checked]="row.visible">
                </mat-checkbox>
            </td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> More info </th>
            <td mat-cell *matCellDef="let row">
                <button mat-icon-button (click)="showQR(row)" *ngIf="row.roadbook_type === 5">
                    <mat-icon svgIcon="qrcode"></mat-icon>
                </button>
            </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="5">
                <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="container" style="padding: 20px;">
                        <mat-card style="background-color: #e9e9e9">
                            <div><span style="font-weight: bold;">Id: </span>{{element.id}} </div>
                            <div><span style="font-weight: bold;">Code: </span>{{element.code}} </div>
                            <div><span style="font-weight: bold;">Name: </span>{{element.name}} </div>
                            <div><span style="font-weight: bold;">Type: </span>{{getRoadbookType(element.roadbook_type)}} </div>
                            <div><span style="font-weight: bold;">Activation code: </span>{{element.activation_code}} </div>
                            <div><span style="font-weight: bold;">Visible: </span>{{(element.visible) ? 'Yes' : 'No'}} </div>
                            <div><span style="font-weight: bold;">Roadbook web: </span>{{getRoadbookName(element.roadbook)}} </div>
                            <div><span style="font-weight: bold;">Pages: </span>{{element.pages}} </div>
                        </mat-card>
                    </div>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row" [class.example-expanded-row]="expandedElement === row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[25, 50, 100, 150]"></mat-paginator>
</div>